import { LangCode } from "../../requests/localization/types";

export type UserSettingsReducer = {
  language: LangCode;
  visibleTitle: boolean;
  visibleDescription: boolean;
  visibleGooglePlay: boolean;
  visibleAppStore: boolean;
  defaultMaxPageRowCount: number | null;
  stateChanged: boolean;
};

export type UserInformationReducer = {
  userName: string;
  email: string;
  showedGuide: boolean;
  stateChanged: boolean;
};

export type UserReducer = {
  settings: UserSettingsReducer;
  information: UserInformationReducer;
  isLoading: boolean;
};

export const userSettingsPLACEHOLDER: UserSettingsReducer = {
  language: LangCode.Czech,
  visibleTitle: false,
  visibleDescription: false,
  visibleAppStore: false,
  visibleGooglePlay: false,
  defaultMaxPageRowCount: null,
  stateChanged: false,
};

export const userInfoPLACEHOLDER: UserInformationReducer = {
  userName: "Uživatelské Jméno",
  email: "Email",
  showedGuide: true,
  stateChanged: false,
};
